import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  Wrench,
  Sparkles,
  ShieldCheck,
  Cpu,
  Package,
  Truck,
  ArrowRight,
  Settings,
} from "lucide-react";
import { resolveImg } from "@/lib/api";

const ICONS = { Wrench, Sparkles, ShieldCheck, Cpu, Package, Truck, Settings };

export default function ServicesSection({ services }) {
  return (
    <section id="servicii" className="py-20 sm:py-28 bg-[#F4F6F9]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#E11D2A] mb-3">
            // Serviciile Noastre
          </p>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#0F1E36]">
            Soluții complete pentru mașina ta
          </h2>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            De la revizii și ITP până la tinichigerie, vopsitorie și diagnoză
            — echipă specializată și echipamente moderne sub același
            acoperiș.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = ICONS[s.icon] || Wrench;
            return (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                data-testid={`service-card-${s.id}`}
                className="group relative bg-white rounded-2xl border border-[#E2E8F0] overflow-hidden hover:border-[#FF5A1F] hover:shadow-xl hover:shadow-slate-200/60 transition-all duration-300"
              >
                {s.image_url ? (
                  <div className="h-44 overflow-hidden">
                    <img
                      src={resolveImg(s.image_url)}
                      alt={s.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                ) : null}
                <div className="p-6">
                  <div className="flex items-start justify-between mb-4">
                    <span className="w-12 h-12 rounded-xl bg-[#0F1E36] flex items-center justify-center group-hover:bg-[#FF5A1F] transition-colors duration-300">
                      <Icon className="w-6 h-6 text-white" />
                    </span>
                    {s.badge ? (
                      <span className="text-[11px] font-bold uppercase tracking-wide text-[#E11D2A] bg-[#E11D2A]/10 px-2.5 py-1 rounded-full">
                        {s.badge}
                      </span>
                    ) : null}
                  </div>
                  <Link to={`/servicii/${s.slug || s.id}`} className="block">
                    <h3 className="font-display text-xl font-bold text-[#0F1E36] leading-snug hover:text-[#FF5A1F] transition-colors duration-200">
                      {s.title}
                    </h3>
                  </Link>
                  <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">
                    {s.description}
                  </p>
                  <div className="mt-5 flex items-center gap-4">
                    <Link
                      to={`/servicii/${s.slug || s.id}`}
                      data-testid={`service-details-link-${s.slug || s.id}`}
                      className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#FF5A1F] hover:text-[#E04B14] transition-colors duration-200"
                    >
                      Vezi detalii
                      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
                    </Link>
                    <a
                      href="#contact"
                      data-testid="service-book-now-button"
                      className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-[#0F1E36] transition-colors duration-200"
                    >
                      Solicită programare
                    </a>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
